import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import dayjs from 'dayjs';
import { getAdminWorkCalendarFilesDataForProjectInTimeFrame } from 'scenes/WorkDemo/services/getAdminWorkCalendarFilesDataForProjectInTimeFrame.service copy';
import { createRequestGetAdminWorkCalendarFilesDataForProjectInTimeFrame } from 'scenes/WorkDemo/utils/requests/createRequestGetAdminFilepermissionsCalendarDataInTimeframe copy';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { createSignedRequest } from '../../utils/createSignedRequest';
import getCredentials from '../../utils/getCredentials';
import { returnMonthlySearchesTimeFrames } from 'scenes/WorkDemo/utils/returnMonthlySearchesTimeFrames.util';

export const loadAdminCalendarFilesDataInTimeframe = createAsyncThunk(
  'workCalendar/loadAdminCalendarFilesDataInTimeframe',
  async (_, { getState }) => {
    const state = getState();

    const { workSearchParams_demo } = state;

    const selectedProjectId = selectSelectedProjectId(state);

    const fromDate = dayjs(workSearchParams_demo.fromDate);
    const toDate = dayjs(workSearchParams_demo.toDate);

    const searchMonthDifference = toDate.diff(fromDate, 'month');

    let returnedFilePermissions = [];

    if (searchMonthDifference > 0) {
      const { accessKeyId, secretAccessKey, sessionToken } =
        await getCredentials();

      const monthlySearches = returnMonthlySearchesTimeFrames(fromDate, toDate);

      const monthlyFilepermissionSearches = monthlySearches.map(
        (monthlySearch) => {
          const request =
            createRequestGetAdminWorkCalendarFilesDataForProjectInTimeFrame(
              selectedProjectId,
              monthlySearch.fromDate,
              monthlySearch.toDate
            );
          return createSignedRequest(
            request,
            accessKeyId,
            secretAccessKey,
            sessionToken
          );
        }
      );

      const filePermissionsSignedRequests = await Promise.all(
        monthlyFilepermissionSearches
      );

      const filesRequestsPromises = filePermissionsSignedRequests.map(
        (request) => axios(request).then((res) => res.data)
      );

      const filesResponses = await Promise.all(filesRequestsPromises);

      returnedFilePermissions = filesResponses
        .map((response) => response.filePermissions)
        .flat();
    } else {
      const filePermissionsResponse =
        await getAdminWorkCalendarFilesDataForProjectInTimeFrame(
          selectedProjectId,
          workSearchParams_demo.fromDate,
          workSearchParams_demo.toDate
        );

      const { filePermissions } = filePermissionsResponse;

      returnedFilePermissions = filePermissions;
    }

    return returnedFilePermissions;
  }
);
